import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import bookingActions from '../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { translationsRootKey, tableConfig } from '../../../../../../settings/index';
import Api, { executeAction } from '../../../../../../helpers/api';
import jobActions from '../../../actions';
import { t } from '../../../../../../i18n';

const teamMembersApi = new Api('shifts/:id/team_members');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', action } = payload;

    const { method, url } = action;

    const result = yield call(
      sendRequest,
      executeAction,
      { url, method, search: { page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records: data, totalCount, filteredCount, sortableColumns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadMyTeamData({ payload }) {
  try {
    const { shiftId: id, page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;

    const result = yield call(
      sendRequest,
      teamMembersApi.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records: data, totalCount, filteredCount, sortableColumns } = result.data.success.data;

      yield put(
        actions.loadMyTeamDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* assignWorker({ payload }) {
  try {
    const { url, method, worker_id, jobId, cb, pages } = payload;

    const executeParams = { url, method };

    if (method === 'put' && worker_id) {
      executeParams.search = { worker_id };
    }

    const result = yield call(sendRequest, executeAction, executeParams, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(bookingActions.closeAssignTalentToShiftModal());

      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`${translationsRootKey}.jobs.bookings.talent_booked_notification`),
        }),
      );

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.LOAD_MY_TEAM, loadMyTeamData),
    takeEvery(actions.SEND_REQUEST, assignWorker),
  ]);
}
